import { render, staticRenderFns } from "./CreditTransaction.vue?vue&type=template&id=07195c28"
import script from "./CreditTransaction.vue?vue&type=script&lang=js"
export * from "./CreditTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports